<template>
    <div class="p-fluid formgrid grid mt-10">
        <div class="field col-12 md:col-4">
            <label for="nik">{{ $t('employee-number') }}</label>
            <InputText id="nik" type="text" v-model="form.nik" :class="{ 'p-invalid': submitted && !form.nik }" />
            <small class="p-invalid" v-if="submitted && !form.nik">{{ $t('employee-number') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="idcard">{{ $t('id-card-number') }}</label>
            <InputText id="idcard" type="text" v-model="form.id_card_number"
                :class="{ 'p-invalid': submitted && !form.id_card_number }" />
            <small class="p-invalid" v-if="submitted && !form.id_card_number">{{ $t('id-card-number') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="idcard">{{ $t('npwp-number') }}</label>
            <InputText id="idcard" type="text" v-model="form.npwp_number"
                :class="{ 'p-invalid': submitted && !form.npwp_number }" />
            <small class="p-invalid" v-if="submitted && !form.npwp_number">{{ $t('npwp-number') }} is required.</small>
        </div>
        <div class="field col-12">
            <label for="name">{{ $t('name') }}</label>
            <InputText id="name" type="text" v-model="form.name" :class="{ 'p-invalid': submitted && !form.name }" />
            <small class="p-invalid" v-if="submitted && !form.name">{{ $t('name') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthplace">{{ $t('birthplace') }}</label>
            <InputText id="birthplace" type="text" v-model="form.birthplace"
                :class="{ 'p-invalid': submitted && !form.birthplace }" />
            <small class="p-invalid" v-if="submitted && !form.birthplace">{{ $t('birthplace') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthdate">{{ $t('birthdate') }}</label>
            <Calendar :showIcon="true" :showButtonBar="true"
                :class="{ 'p-invalid': submitted && !form.birthdate }" v-model="form.birthdate" dateFormat="yy-mm-dd" />
            <small class="p-invalid" v-if="submitted && !form.birthdate">{{ $t('birthdate') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="gender">{{ $t('gender') }}</label>
            <Dropdown v-model="form.gender" :options="genders" option-label="name" option-value="code"
                placeholder="Select Gender" :class="{ 'p-invalid': submitted && !form.gender }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.gender">{{ $t('gender') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="blood_type">{{ $t('blood-type') }}</label>
            <Dropdown v-model="form.blood_type" :options="blood_types" placeholder="Select Blood Type"
                :class="{ 'p-invalid': submitted && !form.blood_type }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.blood_type">{{ $t('blood-type') }} is required.</small>
        </div>
        <div class="field col-12 md:col-6">
            <label for="last_formal_education">{{ $t('last-education') }}</label>
            <Dropdown v-model="form.last_formal_education_id" :options="educations" option-label="name"
                option-value="id" placeholder="Select Education"
                :class="{ 'p-invalid': submitted && !form.last_formal_education_id }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.last_formal_education_id">{{ $t('last-education') }} is
                required.</small>
        </div>
        <div class="field col-12 md:col-2">
            <label for="gpa">{{ $t('gpa') }}</label>
            <InputText id="gpa" type="text" v-model="form.gpa" :class="{ 'p-invalid': submitted && !form.gpa }" />
            <small class="p-invalid" v-if="submitted && !form.gpa">{{ $t('gpa') }} is required.</small>
        </div>
        <div class="field col-12 md:col-2">
            <label for="religion">{{ $t('religion') }}</label>
            <Dropdown v-model="form.religion" :options="religions" placeholder="Select Religion"
                :class="{ 'p-invalid': submitted && !form.religion }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.religion">{{ $t('religion') }} is required.</small>
        </div>
        <div class="field col-12 md:col-2">
            <label for="nationality">{{ $t('nationality') }}</label>
            <Dropdown v-model="form.nationality" :options="nationalities" option-label="name" option-value="id"
                placeholder="Select Nationalities" :class="{ 'p-invalid': submitted && !form.nationality }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.nationality">{{ $t('nationality') }} is required.</small>
        </div>
        <div class="field col-12 md:col-6">
            <label for="clan">{{ $t('clan') }}</label>
            <InputText id="clan" type="text" v-model="form.clan" :class="{ 'p-invalid': submitted && !form.clan }" />
            <small class="p-invalid" v-if="submitted && !form.clan">{{ $t('clan') }} is required.</small>
        </div>
        <div class="field col-12 md:col-2">
            <label for="marital_status">{{ $t('marital-status') }}</label>
            <Dropdown v-model="form.marital_status" :options="marital_statuses" placeholder="Select Marital Status"
                :class="{ 'p-invalid': submitted && !form.marital_status }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.marital_status">{{ $t('marital-status') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="telephone_number">{{ $t('telephone-number') }}</label>
            <InputText id="telephone_number" type="text" v-model="form.telephone_number"
                :class="{ 'p-invalid': submitted && !form.telephone_number }" />
            <small class="p-invalid" v-if="submitted && !form.telephone_number">{{ $t('telephone-number') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="phone_number">{{ $t('phone-number') }}</label>
            <InputText id="phone_number" type="text" v-model="form.phone_number"
                :class="{ 'p-invalid': submitted && !form.phone_number }" />
            <small class="p-invalid" v-if="submitted && !form.phone_number">{{ $t('phone-number') }} is required.</small>
        </div>
        <div class="field col-12 md:col-4">
            <label for="email">{{ $t('email') }}</label>
            <InputText id="email" type="text" v-model="form.email" :class="{ 'p-invalid': submitted && !form.email }" />
            <small class="p-invalid" v-if="submitted && !form.email">{{ $t('email') }} is required.</small>
        </div>
        <div class="field col-12">
            <label for="address">{{ $t('address') }}</label>
            <Textarea id="address" rows="4" v-model="form.address" :class="{ 'p-invalid': submitted && !form.address }" />
            <small class="p-invalid" v-if="submitted && !form.address">{{ $t('address') }} is required.</small>
        </div>
        <div class="field col-12">
            <label for="address_2">Alamat Domisili</label>
            <Textarea id="address_2" rows="4" v-model="form.address_2" :class="{ 'p-invalid': submitted && !form.address_2 }" />
            <small class="p-invalid" v-if="submitted && !form.address_2">Alamat Domisili is required.</small>
        </div>
        <div class="field col-12 md:col-6">
            <label for="email">{{ $t('account-bank-name') }}</label>
            <InputText id="email" type="text" v-model="form.bank.account_name"
                :class="{ 'p-invalid': submitted && !form.bank.account_name }" />
            <small class="p-invalid" v-if="submitted && !form.bank.account_name">{{ $t('account-bank-name') }} is required.</small>
        </div>
        <div class="field col-12 md:col-3">
            <label for="email">{{ $t('bank') }}</label>
            <Dropdown v-model="form.bank.bank_id" :options="banks" option-label="name" option-value="id"
                placeholder="Select Bank" :class="{ 'p-invalid': submitted && !form.bank.bank_id }"></Dropdown>
            <small class="p-invalid" v-if="submitted && !form.bank.bank_id">{{ $t('bank') }} is required.</small>
        </div>
        <div class="field col-12 md:col-3">
            <label for="email">{{ $t('account-bank-number') }}</label>
            <InputText id="email" type="text" v-model="form.bank.account_number"
                :class="{ 'p-invalid': submitted && !form.bank.account_number }" />
            <small class="p-invalid" v-if="submitted && !form.bank.account_number">{{ $t('account-bank-number') }} is required.</small>
        </div>
    </div>
    <div class="grid formgrid right-0">
        <div class="field col-12 md:col-3">
            &nbsp;
            <div class="col-6">
                <label for="foto">{{ $t('Foto') }}</label>
                <Image v-if="(form.foto != 'none' || !form.foto)" :src="form.foto" preview="true" width="250" class="mb-2" />
                <FileUpload mode="basic" name="foto[]" :maxFileSize="3000000" @select="onUpload" chooseLabel="Ganti Foto"/>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import InputText from 'primevue/inputtext';
import Image from 'primevue/image';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Textarea from 'primevue/textarea';

export default {
    components: { InputText, Image, Dropdown, FileUpload, Textarea, TabView, TabPanel, Button, Calendar },
    props: ['submitted'],
    data() {
        return {
            form: this.$page.props.employee ?? {},
            genders: [
                { name: 'Laki-Laki', code: 'Laki-laki' },
                { name: 'Perempuan', code: 'Perempuan' },
            ],
            blood_types: ["A", "B", "O", "AB"],
            educations: "",
            religions: ['Islam', 'Katolik', 'Kristen', 'Hindu', 'Budha'],
            nationalities: "",
            marital_statuses: ['married', 'single', 'widow'],
            banks: "",
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            axios.get(`${this.$page.props.appUrl}api/education-levels`)
                .then((data) => {
                    this.educations = data.data.data
                });
            axios.get(`${this.$page.props.appUrl}api/nationalities`)
                .then((data) => {
                    this.nationalities = data.data.data
                });
            axios.get(`${this.$page.props.appUrl}api/banks`)
                .then((data) => {
                    this.banks = data.data.data
                });
        },
        onUpload(event) {
            // this.form.Image = event.files[0].objectURL;
            let img = event.files[0];
            let formData = new FormData();

            formData.append('image',img);

            axios.post(`${this.$page.props.appUrl}api/employees/${this.form.id}/image`, formData)
            .then((data) => {
                this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
                window.location.reload();
            })
            .catch((error) => {
                this.$toast.add({severity: 'error', summary: "Error", detail: error, life: 3000});
            });
        },
    }
}
</script>
